'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import { Activity } from 'src/components/Atoms/Activity';
import useTranslations from 'src/hooks/useTranslations';
interface LoadingProps {
  message?: string;
  activity?: string;
  fullScreen?: boolean;
  replaceTitle?: boolean;
}
const PageWrapper = styled(FlexColumn)(({
  theme
}) => ({
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1 0 0',
  alignSelf: 'stretch',
  gap: theme.sizes.spacing['09']
}));
const FlexVertical = styled(FlexColumn)(({
  theme
}) => ({
  // maxWidth: '22.5rem', // CSS: CUSTOM VALUE
  alignItems: 'center',
  gap: theme.sizes.spacing['06'],
  justifyContent: 'center',
  borderRadius: theme.sizes.radius.lg
}));
const MessageWrapper = styled(FlexColumn)(({
  theme
}) => ({
  alignItems: 'center',
  gap: theme.sizes.spacing['04'],
  justifyContent: 'center',
  alignSelf: 'stretch'
}));
const AlmostThereText = styled(Typography)(({
  theme
}) => ({
  color: theme.colors.text.primary,
  fontSize: theme.fonts.size['2xl'],
  fontFamily: theme.fonts.family.headline,
  fontWeight: theme.fonts.weight.normal,
  lineHeight: theme.fonts.lineHeight['leading-7'],
  letterSpacing: theme.fonts.letterSpacing.tight
}));
const ActivityText = styled(Typography)(({
  theme
}) => ({
  color: theme.colors.text.secondary,
  fontSize: theme.fonts.size.base,
  fontFamily: theme.fonts.family.body,
  fontWeight: theme.fonts.weight.normal,
  lineHeight: theme.fonts.lineHeight['leading-6'],
  letterSpacing: theme.fonts.letterSpacing.normal
}));
const Loading: React.FC<LoadingProps> = t0 => {
  const $ = _c(18);
  const {
    message: t1,
    activity: t2,
    fullScreen: t3,
    replaceTitle: t4
  } = t0;
  const message = t1 === undefined ? "" : t1;
  const activity = t2 === undefined ? "" : t2;
  const fullScreen = t3 === undefined ? false : t3;
  const replaceTitle = t4 === undefined ? true : t4;
  const {
    t,
    loadingTranslations
  } = useTranslations();
  let t5;
  let t6;
  if ($[0] !== loadingTranslations || $[1] !== replaceTitle || $[2] !== t) {
    t5 = () => {
      if (replaceTitle) {
        document.title = loadingTranslations ? "Loading..." : t("common.loading");
      }
    };
    t6 = [loadingTranslations, t, replaceTitle];
    $[0] = loadingTranslations;
    $[1] = replaceTitle;
    $[2] = t;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  useEffect(t5, t6);
  const t7 = fullScreen ? "100%" : undefined;
  const t8 = fullScreen ? "100%" : undefined;
  let t9;
  if ($[5] !== t7 || $[6] !== t8) {
    t9 = {
      width: t7,
      height: t8
    };
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Activity variant="indeterminate" />;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== activity || $[10] !== loadingTranslations || $[11] !== message) {
    t11 = !loadingTranslations && <MessageWrapper><AlmostThereText>{message}</AlmostThereText><ActivityText>{activity}</ActivityText></MessageWrapper>;
    $[9] = activity;
    $[10] = loadingTranslations;
    $[11] = message;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11) {
    t12 = <FlexVertical>{t10}{t11}</FlexVertical>;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12 || $[16] !== t9) {
    t13 = <PageWrapper sx={t9}>{t12}</PageWrapper>;
    $[15] = t12;
    $[16] = t9;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  return t13;
};
export default Loading;
export type { LoadingProps };